export const ABOUT_US_CARD_KEYS = ['craft', 'gifts', 'speed'] as const;
